import React from 'react';

const MessageSubHeading = ({ text, className }) => {
    return (
        <h6 className={`summary-label theme-text-color mb-2 ${className || ''}`}>
            {text}
        </h6>
    );
};

export default MessageSubHeading;